/**
 * Ð—Ð°Ð¿Ñ€Ð°ÑˆÐ¸Ð²Ð°ÐµÑ‚ iframe Ñ Ð¸Ð½Ñ„Ð¾Ñ€Ð¼Ð°Ñ†Ð¸ÐµÐ¹ Ð¾ ÐºÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ð°Ñ… Ð¸ Ð²Ð¾Ð·Ð²Ñ€Ð°Ñ‰Ð°ÐµÑ‚ ÐµÐµ
 * @param {function} cb ÐšÐ¾Ð»Ð»Ð±ÑÐº Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð»ÑƒÑ‡ÐµÐ½Ð¸Ñ Ð´Ð°Ð½Ð½Ñ‹Ñ…
 * @param {function} getIframe ÐšÐ¾Ð»Ð»Ð±ÑÐº Ð´Ð»Ñ Ð¿Ð¾Ð»ÑƒÑ‡ÐµÐ½Ð¸Ñ ÑÑÑ‹Ð»ÐºÐ¸ Ð½Ð° Ñ„Ñ€ÐµÐ¹Ð¼
 * @returns {undefined}
 */
export function getMessengerContacts(cb, getIframe) {
    window.addEventListener('message', ({ data, origin }) => {
        if (
            window.location.origin === origin &&
            data.type === 'share_iframe' &&
            data.payload &&
            Array.isArray(data.payload.items)
        ) {
            cb(data.payload.items);
        }
    });

    // Ð‘Ñ€Ð°ÑƒÐ·ÐµÑ€ Ð½Ðµ Ð¿Ð¾Ð´ÑÑ‚Ð°Ð²Ð»ÑÐµÑ‚ Ð² iframe Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Origin, ÐºÐ¾Ñ‚Ð¾Ñ€Ñ‹Ð¹ Ð½ÑƒÐ¶ÐµÐ½ Ð¼ÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€Ñƒ
    fetch('https://api.messenger.yandex.ru/share/index.html', { credentials: 'include' })
        .then(response => {
            if (!response.ok) {
                throw new Error('Couldn\'t get contacts from the Messenger');
            }

            response.text().then(response => {
                const iframeDoc = getIframe().contentDocument;
                iframeDoc.open().write(response);
                iframeDoc.close();
            });
        })
        .catch(err => {
            console.error(err);
            cb([]);
        });
}
